module.exports = __webpack_public_path__ + "img/prevent-3.f8716813.png";